import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import InlineIconButton from "../../../../../Buttons/InlineIconButton/InlineIconButton";
import StyledTooltip from "../../../../../StyledTooltip/StyledTooltip";

export default function EditCarrierContactAction({
  activeCarrier,
  contact,
  actionCallback
}) {
  return (
    <StyledTooltip title="Edit">
      <Box>
        <InlineIconButton
          onClick={() => {
            localStorage.setItem("carrier-contact", JSON.stringify(contact));

            actionCallback({
              action: "carrier-contact",
              subaction: "edit-contact",
              carrierId: activeCarrier.id
            });
          }}
          icon={EditOutlinedIcon}
          buttonColor="blue"
        />
      </Box>
    </StyledTooltip>
  );
}

EditCarrierContactAction.propTypes = {
  activeCarrier: PropTypes.object,
  contact: PropTypes.object.isRequired,
  actionCallback: PropTypes.func.isRequired
};